import { styles } from './FilterSelect.styles';
import type { FilterSelectProps } from './FilterSelect.types';

/**
 * One dropdown of the listing's filter bar.
 *
 * The empty string is the "no filter" value rather than a sentinel like `all`,
 * so the caller can spread the state straight into the query params and an
 * unset filter simply never reaches the API.
 */
export const FilterSelect = ({ value, onChange, options, allLabel, optionLabel, ariaLabel }: FilterSelectProps) => (
	<select
		className={styles.select}
		value={value}
		aria-label={ariaLabel}
		onChange={(event) => onChange(event.target.value)}
	>
		<option value="">{allLabel}</option>
		{options.map((option) => (
			<option key={option} value={option}>
				{optionLabel(option)}
			</option>
		))}
	</select>
);
